import type { TaskCheckResponse } from '@/types/apps/task-check.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Creatable } from '@/types/service/creatable.interface';
import type { Indexable } from '@/types/service/indexable.interface';
import type { Showable } from '@/types/service/showable.interface';

type TaskRepeatListResponse = ApiResponse<PaginatedResult<TaskCheckResponse>>;

export class TaskRepeatService implements Showable, Creatable, Indexable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/task-repeat',
        detail: (id: string) => `/api/task-repeat/${id}`,
    };

    public async index(params?: QueryParams): Promise<TaskRepeatListResponse> {
        return this.apiClient
            .fetchApi<
                PaginatedResult<TaskCheckResponse>
            >(this.endpoints.base(), params)
            .then(res => {
                return {
                    ...res,
                    result: {
                        ...res.result,
                        items: res.result.items.map(item => ({
                            ...item,
                            customName: `${item.code} - ${item.name}`,
                        })),
                    },
                };
            });
    }

    public detail(
        id: string,
        params?: QueryParams
    ): Promise<ApiResponse<TaskCheckResponse>> {
        const url = this.endpoints.detail(id);

        return this.apiClient.fetchApi(url, params);
    }

    public create(payload: {
        id: string;
    }): Promise<ApiResponse<TaskCheckResponse>> {
        return this.apiClient.postApi(this.endpoints.base(), payload);
    }
}
